import React, { useCallback, useEffect, useState } from 'react'
import anylogger from '@app/anylogger'
const log = anylogger('isBrowserServer')

export function isBrowserServer(): { isBrowser: boolean; isServer: boolean } {
	const isBrowser = typeof window !== 'undefined'
	return { isBrowser, isServer: !isBrowser }
}
